import React from 'react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { User, Calendar, Tag, AlertCircle, FileText, CheckCircle2 } from 'lucide-react';
import { SummarizeButton } from '../shared/SummarizeButton';
export function IssueDetailArtifact({
  data
}: {
  data: any;
}) {
  if (!data) return null;
  const key = data.key;
  const fields = data.fields || data;
  const summary = fields.summary || 'Sin título';
  const description = fields.description || 'Sin descripción';
  const status = fields.status?.name || data.status || 'To Do';
  const priority = fields.priority?.name || data.priority || 'Medium';
  const assignee = fields.assignee?.displayName || data.assignee?.name || 'Unassigned';
  const reporter = fields.reporter?.displayName || data.reporter?.name || 'Unknown';
  const created = fields.created || data.createdDate || 'N/A';
  const type = fields.issuetype?.name || data.type || 'Task';
  const labels = fields.labels || data.labels || [];
  return <div className="p-5 bg-slate-900" data-id="element-184">
      <div className="flex items-start justify-between mb-4" data-id="element-185">
        <div data-id="element-186">
          <div className="flex items-center gap-2 mb-1" data-id="element-187">
            <span className="text-xs font-bold text-indigo-400 bg-indigo-950/50 px-2 py-0.5 rounded border border-indigo-900/50" data-id="element-188">
              {key}
            </span>
            <span className="text-xs text-slate-500 font-medium uppercase tracking-wider" data-id="element-189">
              {type}
            </span>
          </div>
          <h3 className="text-lg font-bold text-slate-100 leading-tight" data-id="element-190">
            {summary}
          </h3>
        </div>
        <div className="flex flex-col items-end gap-2" data-id="element-191">
          <span className="px-2.5 py-1 rounded-md text-xs font-bold bg-slate-800 text-slate-300 border border-slate-700 shadow-sm" data-id="element-192">
            {status}
          </span>
          <span className={`text-xs font-bold flex items-center gap-1 ${priority.toLowerCase().includes('high') ? 'text-red-400' : priority.toLowerCase().includes('medium') ? 'text-amber-400' : 'text-emerald-400'}`} data-id="element-193">
            <AlertCircle size={12} data-id="element-194" /> {priority}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-5 p-4 bg-slate-950/50 rounded-lg border border-slate-800" data-id="element-195">
        <div className="flex items-center gap-2 text-sm" data-id="element-196">
          <User size={14} className="text-slate-500" data-id="element-197" />
          <span className="text-slate-400" data-id="element-198">Assignee:</span>
          <span className="text-slate-200 font-medium" data-id="element-199">{assignee}</span>
        </div>
        <div className="flex items-center gap-2 text-sm" data-id="element-200">
          <User size={14} className="text-slate-500" data-id="element-201" />
          <span className="text-slate-400" data-id="element-202">Reporter:</span>
          <span className="text-slate-200 font-medium" data-id="element-203">{reporter}</span>
        </div>
        <div className="flex items-center gap-2 text-sm" data-id="element-204">
          <Calendar size={14} className="text-slate-500" data-id="element-205" />
          <span className="text-slate-400" data-id="element-206">Created:</span>
          <span className="text-slate-200 font-medium" data-id="element-207">
            {new Date(created).toLocaleDateString()}
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm" data-id="element-208">
          <CheckCircle2 size={14} className="text-slate-500" data-id="element-209" />
          <span className="text-slate-400" data-id="element-210">Points:</span>
          <span className="text-slate-200 font-medium font-mono" data-id="element-211">
            {fields.customfield_10016 || data.points || '-'}
          </span>
        </div>
      </div>

      {labels.length > 0 && <div className="flex items-center gap-2 mb-5 flex-wrap" data-id="element-212">
          <Tag size={14} className="text-slate-500" data-id="element-213" />
          {labels.map((l: string, i: number) => <span key={i} className="text-[10px] font-medium text-slate-400 bg-slate-800 px-2 py-0.5 rounded-full border border-slate-700" data-id="element-214">
              {l}
            </span>)}
        </div>}

      <div data-id="element-215">
        <h4 className="text-sm font-semibold text-slate-300 mb-2 flex items-center gap-1.5" data-id="element-216">
          <FileText size={14} data-id="element-217" /> Description
        </h4>
        <div className="text-sm text-slate-400 bg-slate-950 p-4 rounded-lg border border-slate-800 whitespace-pre-wrap leading-relaxed" data-id="element-218">
          {typeof description === 'string' ? description : JSON.stringify(description)}
        </div>

        <SummarizeButton content={typeof description === 'string' ? description : JSON.stringify(description)} title={`${key}: ${summary}`} contextType="ticket de Jira" variant="inline" data-id="element-219" />
      </div>
    </div>;
}